import IFieldVisitor from "./IFieldVisitor";

export default interface IField {
    id: string;
    name: string;
    type: FieldType;
    searchable: boolean;
    nullable: boolean;
    __typename: string;
    behaviors: FieldBehaviors;
    order: number;
    accept<T>(visitor: IFieldVisitor<T>) : T;
}

export enum FieldType {
    Text = "TEXT",
    Array = "ARRAY",
    Enum = "ENUM",
    LengthInterval = "LENGTHINTERVAL",
    Image = "IMAGE",
    Boolean = "BOOLEAN"
}

export enum FieldBehaviors {
    None = 0,
    Identification = 1 << 0,
    Title = 1 << 1,
    SubTitle = 1 << 2,
    Description = 1 << 3,
    DefaultCollapsed = 1 << 4
}


// WEBPACK FOOTER //
// ./src/metamodel/IField.ts